module.exports = __webpack_public_path__ + "static/media/pickleradish.c6655fc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/pickleradish.jpg
// module id = 131
// module chunks = 0